import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import VehicleManualEnterForm from '@components/VehicleManualEnterForm/VehicleManualEnterForm';

const VehicleManualEnter = () => {
  const { t } = useTexts();

  return (
    <>
      <VehicleManualEnterForm />

      <Footer text={t('vehicleManualEnter.footer')} />
    </>
  );
};

export default VehicleManualEnter;
